import {
  TelemetryConfig,
  getTelemetryConnectionString,
} from "@knowfully/ui.common";
import { OrganizationAdminApplicationId } from "constants/application";
import { useEffect, useState } from "react";
import authStore from "stores/authStore";
import contextStore from "stores/contextStore";

const STATIC_TELEMETRY_CONFIG = {
  cloudRoleName: "orgportal-frontend",
  enableAutoRouteTracking: true,
  disableAjaxTracking: false,
  disableFetchTracking: false,
  enableUnhandledPromiseRejectionTracking: true,
  devConsoleMode: window.location.hostname === "localhost",
} as const;

const addTelemetryContext = () => {
  const authData = authStore.getRawState();
  const contextData = contextStore.getRawState();

  return {
    userId: authData.id,
    email: authData.email,
    impersonatedUserEmail: authData.impersonatedUserEmail,
    isImpersonating: !!authData.impersonatedUserEmail,
    organizationId: contextData.organization?.id,
    organizationName: contextData.organization?.name,
    applicationId: OrganizationAdminApplicationId,
  };
};

export function useTelemetryConfig(): TelemetryConfig | null {
  const [config, setConfig] = useState<TelemetryConfig | null>(null);

  useEffect(() => {
    getTelemetryConnectionString().then((connectionString) => {
      setConfig({
        ...STATIC_TELEMETRY_CONFIG,
        addTelemetryContext,
        connectionString: connectionString || undefined,
      });
    });
  }, []);

  return config;
}
